// src/utils/i18n.js
// Simple i18n loader for JSON string files in /src/locales/{lang}/strings.json

import logger from './logger';

export class I18n {
  constructor(defaultLang = 'en') {
    this.lang = defaultLang;
    this.strings = {};
  }

  async load(lang) {
    try {
      const mod = await import(`../locales/${lang}/strings.json`);
      this.strings = mod.default || mod;
      this.lang = lang;
    } catch (e) {
      logger.error(`Could not load locale for ${lang}:`, e);
      this.strings = {};
    }
  }

  /**
   * Translate a key with optional variable interpolation.
   * Usage: t('CallDetailListItem.formattedDuration', { numMin: 5, numSec: 12 })
   * @param {string} key - The translation key (dot notation)
   * @param {object} [vars] - Variables for interpolation
   * @param {string} [defaultValue] - Fallback if key not found
   */
  t(key, vars = {}, defaultValue) {
    // Dot notation lookup
    let value = key.split('.').reduce((o, k) => (o || {})[k], this.strings);
    if (value === undefined) value = defaultValue || key;
    // Interpolate {var} and {{var}}
    if (typeof value === 'string' && vars && Object.keys(vars).length > 0) {
      value = value.replace(/\{\{?(\w+)\}?\}/g, (match, v) =>
        Object.prototype.hasOwnProperty.call(vars, v) ? vars[v] : match,
      );
    }
    return value;
  }
}
